// rg-oferta-carrusel: "Añadir al carrito" por tarjeta en el carrusel de la
// oferta de guantes. Usa el endpoint estandar de Shopify (/cart/add.js) --
// no crea ningun descuento por si solo, solo agrega el guante elegido al
// carrito. El descuento de $20.000 (creado como descuento automatico nativo
// en Shopify) se activa por si solo unicamente cuando el carrito tiene 2 o
// mas guantes elegibles -- con 1 solo, el carrito no debe mostrar ningun
// descuento.
(function () {
  function setMsg(card, text, tone) {
    var msg = card.querySelector('.rg-oferta__card-msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    if (tone) {
      msg.setAttribute('data-tone', tone);
    } else {
      msg.removeAttribute('data-tone');
    }
  }

  function handleAdd(carrusel, card) {
    var select = card.querySelector('.rg-oferta__card-talla');
    var btn = card.querySelector('.rg-oferta__card-add');
    var addUrl = carrusel.dataset.cartAddUrl;
    var cartUrl = carrusel.dataset.cartUrl;

    if (!select || !select.value) {
      setMsg(card, 'Elige una talla', 'error');
      return;
    }

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Agregando…';
    setMsg(card, '', null);

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: select.value, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var errorMsg = (result.data && result.data.description) || 'No se pudo agregar. Intenta de nuevo.';
          setMsg(card, errorMsg, 'error');
          btn.disabled = false;
          btn.textContent = originalText;
          return;
        }
        setMsg(card, 'Agregado. Llevando 2, el descuento se ve en el carrito.', 'ok');
        window.location.href = cartUrl;
      })
      .catch(function () {
        setMsg(card, 'No se pudo agregar. Intenta de nuevo.', 'error');
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // rg (bug-check 07-10-2026): UN solo escucha de clics para toda la página, en vez de uno por carrusel.
  //  - C1: este archivo se carga 2 veces (ficha: bloque rg-oferta-relacionada; carro lateral: rg-cart-upsell) y cada
  //    copia le ponía su propio escucha a cada carrusel -> 1 clic = 2 POST /cart/add = 2 guantes en el carro.
  //  - I3: el carrusel del carro lateral se vuelve a dibujar cada vez que cambia el carro y el nuevo quedaba sin
  //    escucha -> "Añadir" no hacía nada. Escuchando en el documento, sirve también para carruseles que aparecen después.
  if (window.__rgOfertaCarrusel) return;
  window.__rgOfertaCarrusel = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.rg-oferta__card-add');
    if (!btn || btn.disabled) return;
    var carrusel = btn.closest('[data-rg-oferta-carrusel]');
    var card = btn.closest('.rg-oferta__card');
    if (carrusel && card) handleAdd(carrusel, card);
  });
})();
